// extracted by mini-css-extract-plugin
export default {"cvBlock":"Cv_cvBlock__jYaDE","cvContainer":"Cv_cvContainer__Rrn+g","cvImage":"Cv_cvImage__74pAh","cvImageOpen":"Cv_cvImageOpen__KH7XK","button":"Cv_button__jcFAb"};